import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {
  date as DATE,
  urls as urlHelpers
} from './../helpers';
import {
  Modal,
  Button,
  Row,
  Col,
  Glyphicon
} from 'react-bootstrap';

const Author = ({ children }) => <span style={{ fontWeight: 'bold' }}>{children}</span>;

Author.propTypes = { children: PropTypes.string.isRequired };

const DateView = ({ date }) =>
  <span>{DATE.friendlyDate(date)} ({Moment(date).fromNow()})</span>;

DateView.propTypes = { date: PropTypes.string.isRequired };

const Comment = ({ comment }) => comment ?
  <span>{comment}</span> :
  <span style={{ fontStyle: 'italic' }}>No comment text.</span>;

Comment.propTypes = { comment: PropTypes.string };

const Ticket = ({ number }) => number ?
  <span>
    Ticket: <a href={`${urlHelpers.JIRA_BASE_URL}/browse/${number}`} target="_blank">
      {number}
    </a>
  </span> :
  null;

Ticket.propTypes = { number: PropTypes.string };

const ShowCommentsModalComponent = ({
  annotations,
  glyphFunc,
  visible,
  onHide,
  removeAnnotation,
  ticketsOnly,
  setTicketsOnly
}) => {
  return (
    <Modal show={visible} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Comments for</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'block' }} className="pull-right">
          <label>
            Only Comments With Ticket
            <input
              type="checkbox"
              checked={ticketsOnly}
              style={{ marginLeft: '10px' }}
              onChange={e => setTicketsOnly(e.target.checked)}
            />
          </label>
        </div>
        <br />
        {annotations
          .filter(a => ticketsOnly ? a.ticket : a)
          .map((annotation, i) => (
            <div key={i}>
              <Row>
                <Col sm={1}>
                  <Glyphicon glyph={glyphFunc(annotation)} />
                </Col>
                <Col sm={8}>
                  <div>
                    <Author>
                      {annotation.user}
                    </Author> - <DateView date={annotation.created_at} />
                  </div>
                  <Comment comment={annotation.comment} />
                  <div>
                    <Ticket number={annotation.ticket} />
                  </div>
                </Col>
                <Col sm={3}>
                  <Button onClick={removeAnnotation.bind(this, annotation.id)}>
                    Remove
                  </Button>
                </Col>
              </Row>
              {i + 1 < annotations.length ? <hr style={{ margin: '7px' }} /> : null}
            </div>
          ))
        }
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

ShowCommentsModalComponent.propTypes = {
  visible: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  annotations: PropTypes.array.isRequired,
  removeAnnotation: PropTypes.func.isRequired,
  glyphFunc: PropTypes.func.isRequired,
  ticketsOnly: PropTypes.bool,
  setTicketsOnly: PropTypes.func.isRequired
};

export default ShowCommentsModalComponent;


// WEBPACK FOOTER //
// src/Components/ShowCommentsModalComponent.jsx